import { getDropdownOptions } from "helpers/DropdownHelper";
import { BoolArrayFilter, IsNotificationReadTranslation } from "modules/common/constants";
import React from "react";
import { Filter } from "../Filter";
import { ToggleSwitch } from "../ToggleSwitch";

interface Props {
    onChange: (isRead: BoolArrayFilter) => void;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClear: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
    isActive: boolean;
    showDropdown: boolean;
    value: BoolArrayFilter[];
}

export const IsNotificationReadFilter: React.FC<Props> = ({
    onChange,
    onClick,
    onClear,
    isActive,
    showDropdown,
    value,
}) => {
    const renderFilter = () =>
        getDropdownOptions(IsNotificationReadTranslation).map(option => (
            <div key={option.value}>
                <ToggleSwitch
                    key={option.value}
                    value={option.label}
                    checked={value.includes(option.value)}
                    onChange={() => onChange(option.value)}
                    htmlFor={option.label}
                    text={
                        <div className="filter__item__text">{option.label.toLocaleUpperCase()}</div>
                    }
                />
            </div>
        ));

    return (
        <Filter
            isActive={isActive}
            showDropdown={showDropdown}
            onClick={onClick}
            onClear={onClear}
            text="PROČITANOST"
        >
            {renderFilter()}
        </Filter>
    );
};
